import shopCar from './shopCar.vue';
export default shopCar;